<template>
  <section-container>
    <header-page
      title_header="Adicionar novo Produto"
      sub_header="Adicione novo produto no catalogo da sua loja"
    />
    <content-e class="p-2">
      <div class="bg-white shadow-2l rounded p-6">
        <h2
          class="
            text-md
            font-bold
            mb-4
            pb-4
            border-b border-dashed
            block
            w-full
          "
        >
          Informações do produto
        </h2>
        <form
          action=""
          class="flex flex-wrap w-full"
          @submit.prevent="doStoreProduct"
          ref="formProduct"
        >
          <div class="w-full md:w-2/3 p-2 mx-auto">
            <div class="flex flex-wrap">
              <div class="w-full">
                <div class="w-full flex items-center justify-center">
                  <uploader
                    v-model="images"
                    :after-read="afterRead"
                    :before-delete="beforeDelete"
                    multiple
                    result-type="file"
                    :preview-size="115"
                    :max-count="modules.product_images"
                    :preview-full-image="false"
                    :preview-options="{ asyncClose: true, closeable: true }"
                  >
                    <template #preview-cover="file">
                      <div class="preview-cover van-ellipsis" v-if="file.id">
                        <ui-radio v-model="thumb_image" :true-value="file.id"
                          >Image principal</ui-radio
                        >
                      </div>
                    </template>
                  </uploader>
                </div>
                <div class="w-full my-4">
                  <category-modal
                    :store_id="storeId"
                    @created="doLoadCategoriesByProduct"
                  ></category-modal>
                </div>
                <div class="w-full p-2">
                  <ui-select
                    icon="bookmark_border"
                    placeholder="Selecione sua categoria"
                    :options="categories"
                    v-model="categories_selected"
                    multiple
                    help="Selecione categorias que seu produto será exibido"
                    has-search
                  ></ui-select>
                </div>
              </div>
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'shopping-bag', type: 'solid' }"
                  id="name"
                  name="name"
                  type="text"
                  v-model="name"
                  label="Nome do produto:"
                ></input-icon>
              </div>
              <div class="w-full md:w-1/3 p-2">
                <input-icon
                  :icon="{ name: 'purchase-tag', type: 'solid' }"
                  id="price"
                  v-currency
                  name="price"
                  type="text"
                  v-model="price"
                  label="Preço:"
                ></input-icon>
              </div>

              <div class="w-full md:w-1/3 p-2">
                <input-icon
                  :icon="{ name: 'purchase-tag', type: 'solid' }"
                  id="cost_price"
                  v-currency
                  name="cost_price"
                  type="text"
                  v-model="cost_price"
                  label="Preço de Custo (Opcional):"
                ></input-icon>
              </div>
              <div class="w-full md:w-1/3 p-2">
                <input-icon
                  :icon="{ name: 'shopping-bag', type: 'solid' }"
                  id="sku"
                  name="sku"
                  type="text"
                  v-model="sku"
                  label="SKU:"
                ></input-icon>
              </div>
              <div class="w-full p-2">
                <label for="" class="text-sm mb-2">Descrição:</label>
                <quill-editor
                  class="rounded-lg"
                  ref="myQuillEditor"
                  v-model="description"
                  :options="editorOption"
                />
              </div>
              <div class="w-full p-2">
                <h3 class="text-sm my-2">
                  Variações
                  <span class="bg-yellow-500 text-gray-800 px-3 py-1 rounded text-xs">Assinantes Pro</span>
                </h3>
                <div class="p-4 rounded bg-gray-100">
                  <VariationModal
                    v-model="variations"
                    :variations="variations"
                  />
                </div>
              </div>
              <!-- <div class="w-full md:w-1/2 p-2">
                <ui-switch v-model="stock_manager" >
                  <span class="font-display">Gerenciar Estoque</span>
                </ui-switch>
                <input-icon
                  v-if="stock_manager"
                  :icon="{ name: 'package', type: 'solid' }"
                  id="stock"
                  name="stock"
                  type="number"
                  v-model="stock"
                  label="Estoque:"
                ></input-icon>
              </div> -->
              <div class="w-full mb-4 p-2">
                <ui-switch v-model="display">
                  <span class="font-display text-lg"
                    >Exibir produto no catálogo?</span
                  >
                </ui-switch>
              </div>
              <div class="w-full p-2">
                <button-icon
                  icon="plus"
                  :text="
                    this.$route.params.product
                      ? `Atualizar Produto`
                      : `Adicionar Produto`
                  "
                  class="bg-indigo-600"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </content-e>
  </section-container>
</template>

<script>
import CategoryModal from '@/components/Store/Category/CategoryModal'
import VariationModal from '@/components/Store/VariationModal'
import UiRadio from 'keen-ui/lib/UiRadio'
import { parse } from 'vue-currency-input'
import { Uploader } from 'vant'
import 'vant/lib/uploader/style'

export default {
  components: {
    CategoryModal,
    Uploader,
    VariationModal,
    UiRadio
  },
  computed: {
    storeId() {
      return this.$store.state.store.id
    },
    modules() {
      return this.$store.getters.modules
    }
  },
  data() {
    return {
      categoryModalShow: false,
      update: false,
      name: '',
      display: false,
      thumb_image: '',
      images: [],
      previewImage: require('@/assets/img/photo_upload.png'),
      description: '',
      price: '',
      sku: '',
      special_start: null,
      categories: [],
      variations: [],
      categories_selected: [],
      cost_price: '',
      stock_manager: false,
      promotion: false,
      stock: 0,
      editorOption: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ align: [] }],
            ['clean'] // remove formatting button
          ]
        },
        placeholder: 'Descrição do produto'
      },
      options: {
        currency: 'BRL',
        distractionFree: false,
        valueAsInteger: false,
        autoDecimalMode: true
      }
    }
  },
  methods: {
    picker9Formatter(date) {
      return date.toLocaleDateString()
    },
    openModal(ref) {
      this.$refs[ref].open()
    },
    async beforeDelete(file) {
      file.status = 'uploading'
      file.message = 'Removendo...'
      await this.$store.dispatch('store/DELETE_PRODUCT_IMAGE', {
        product_id: this.$route.params.product,
        image_id: file.id
      })
    },
    async afterRead(file) {
      if (Array.isArray(file)) {
        file.forEach(async (item, index) => {
          file[index].status = 'uploading'
          file[index].message = 'Carregando...'
          const formData = new FormData()
          formData.append('image', item.file)
          const image = await this.$store.dispatch(
            'store/UPLOAD_PRODUCT_IMAGE',
            {
              product_id: this.$route.params.product,
              form: formData
            }
          )
          file[index].status = ''
          file[index].url = `${this.$settings.image_url}/${image.data.path}`
          file[index].id = image.data.id
        })
      } else {
        file.status = 'uploading'
        file.message = 'Carregando...'
        const formData = new FormData()
        formData.append('image', file.file)
        const image = await this.$store.dispatch('store/UPLOAD_PRODUCT_IMAGE', {
          product_id: this.$route.params.product,
          form: formData
        })
        file.status = ''
        file.url = `${this.$settings.image_url}/${image.data.path}`
        file.id = image.data.id
      }
      this.thumb_image = this.images[0].id
    },
    async doLoadCategoriesByProduct(e) {
      const categories = await this.$store.dispatch(
        'store/LOAD_CATEGORIES_BY_STORE',
        this.storeId
      )
      if (e) {
        this.categories_selected.push({
          label: e.name,
          value: e.id
        })
      }
      this.categories = categories.data.map(category => {
        return {
          label: category.name,
          value: category.id
        }
      })
    },
    doLoadProductById() {
      const data = {
        store_id: this.storeId,
        product_id: this.$route.params.product
      }
      this.$store
        .dispatch('store/LOAD_PRODUCT_BY_STORE', data)
        .then(response => {
          this.previewImage = `${this.$settings.image_url}/store/${data.store_id}/product/images/${data.product_id}/thumb.jpg`
          const product = response.data
          this.name = product.name
          this.sku = product.sku
          this.description = product.description
          this.thumb_image = product.image_id
          this.variations = product.variations
          this.price = this.$options.filters.toCurrency(product.price)
          this.cost_price = this.$options.filters.toCurrency(product.cost_price)
          if (product.manager_stock) {
            this.stock = product.stock.qty
            this.stock_manager = product.manager_stock
          }
          this.display = product.display
          this.images = product.images.map(data => {
            return {
              url: `${this.$settings.image_url}/${data.path}`,
              id: data.id,
              status: '',
              message: ''
            }
          })
          this.categories_selected = product.categories.map(category => {
            return {
              label: category.name,
              value: category.id
            }
          })
        })
    },
    doStoreProduct(e) {
      // console.log(this.images)
      // const formData = new FormData()

      // if (this.$refs.formProduct.image_upload.files.length > 0) {
      //   formData.append('image', this.$refs.formProduct.image_upload.files[0])
      // }
      // formData.append('name', this.name)
      // formData.append('manager_stock', this.stock_manager)
      // formData.append('sku', this.sku)
      // formData.append('description', this.description)
      // formData.append('price', parse(this.price, this.options) ?? 0)
      // formData.append('cost_price', parse(this.cost_price, this.options) ?? 0)
      // formData.append('stock', this.stock_manager ? this.stock : 0)
      const categories = this.categories_selected.map(category => {
        return category.value
      })

      const data = {
        name: this.name,
        images: this.images,
        manager_stock: this.stock_manager,
        sku: this.sku,
        image_id: this.thumb_image,
        description: this.description,
        price: parse(this.price, this.options) ?? 0,
        cost_price: parse(this.cost_price, this.options) ?? 0,
        stock: this.stock_manager ? this.stock : 0,
        categories,
        variations: this.variations,
        display: this.display
      }

      if (this.$route.params.product) {
        data.product_id = this.$route.params.product
      }

      this.$store
        .dispatch(
          `store/${
            this.$route.params.product
              ? 'UPDATE_PRODUCT_STORE'
              : 'CREATE_PRODUCT_STORE'
          }`,
          data
        )
        .then(response => {
          this.$toasted.success('Produto adicionado com sucesso!', {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
          this.$router.push({
            name: 'store.product.index'
          })
        })
        .catch(error => {
          const msg = Object.values(error.data.errors)
          msg.forEach((item, i) => {
            this.$toasted.error(item, {
              position: 'top-center',
              duration: 5000,
              icon: 'close'
            })
          })
        })
    }
  },
  created() {
    if (this.$route.params.product) {
      this.doLoadProductById()
    }
    this.doLoadCategoriesByProduct()
  }
}
</script>

<style>
.preview-cover {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: rgba(62, 41, 248, 0.274);
}
</style>
